import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dots-horizontal",
  "use": "dots-horizontal-usage",
  "viewBox": "0 0 16 4",
  "content": "<symbol viewBox=\"0 0 16 4\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dots-horizontal\">\n    <circle cx=\"2\" cy=\"2\" r=\"2\" />\n    <circle cx=\"8\" cy=\"2\" r=\"2\" />\n    <circle cx=\"14\" cy=\"2\" r=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol